import React from 'react';
import { cn } from '../lib/utils';

export function TitleMeta({ items = [], className }) {
  const parts = items.filter(Boolean);
  if (parts.length === 0) return null;

  return (
    <div className={cn('flex items-center gap-2 text-muted-foreground text-xs', className)}>
      {parts.map((part, index) => (
        <span key={`${part}-${index}`} className="flex items-center gap-2">
          {index > 0 ? (
            <span aria-hidden className="h-3 w-px shrink-0 bg-current opacity-30" />
          ) : null}
          <span className="whitespace-nowrap">{part}</span>
        </span>
      ))}
    </div>
  );
}

export function typeLabel(title) {
  if (!title) return 'Movie';
  return title.isSeries || title.IsSeries ? 'Series' : 'Movie';
}
